export const multiPropertyPaths = {
  MULTI_PROPERTY: "",
  MULTI_PROPERTY_BALANCE_MOVEMENT_IN: "balance-movement-in",
  MULTI_PROPERTY_BALANCE_MOVEMENT_OUT: "balance-movement-out",
};
